export default __webpack_public_path__ + "images/9cd62159d59d013b9f173460305d1a2c.svg";